import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { Estrategia } from "../models/estrategia.model";

@Injectable()
export class EstrategiaService {
    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Basket por id
     * @param id ID da Basket
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "renda-variavel/estrategia-rv/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Basket por id
     * @param id ID da Basket
     */
    getNextCode(): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "renda-variavel/estrategia-rv/next-code", {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Basket
     * @param id ID da Basket
     */
    getAll(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "renda-variavel/estrategia-rv" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Profissão do Cliente Para Campo Do Cadastro
     */
    getLista(): Observable<ApiPaginationResponseDataNonNullable<Estrategia>> {
        return this._http.get<ApiPaginationResponseDataNonNullable<Estrategia>>(
            this.utilitesService.urlPrefix + "renda-variavel/estrategia-rv/lista",
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Delete Basket
     * @param id ID do Basket
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "renda-variavel/estrategia-rv/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Basket
     * @param params Json Basket
     */
    create(params: any): Observable<any> {
        return this._http.post(
            this.utilitesService.urlPrefix + "renda-variavel/estrategia-rv",
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * AtualizaBasket
     * @param params Json Basket
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(
            this.utilitesService.urlPrefix + "renda-variavel/estrategia-rv/" + id,
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }
}
